export const splitImage = (img: string) => {
  return img
}